"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Headings = exports.H1 = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _primitives = require("../primitives");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Headings = _styledComponents.default.div(_templateObject());

exports.Headings = Headings;

var H1 = function H1(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h1"
  }, p));
};

exports.H1 = H1;
H1.defaultProps = {
  fontFamily: 'brand',
  lineHeight: 1.5,
  fontSize: 7,
  color: 'blue',
  fontWeight: 'light',
  m: 0
};

var H2 = function H2(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h2"
  }, p));
};

H2.defaultProps = {
  lineHeight: 1.5,
  fontSize: 6,
  color: 'blue.dark',
  fontWeight: 'light',
  fontFamily: 'default',
  m: 0
};

var H3 = function H3(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h3"
  }, p));
};

H3.defaultProps = {
  lineHeight: 1.5,
  fontSize: 5,
  color: 'blue.dark',
  fontWeight: 'normal',
  fontFamily: 'default',
  m: 0
};

var H4 = function H4(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h4"
  }, p));
};

H4.defaultProps = {
  lineHeight: 1.5,
  fontSize: 4,
  fontWeight: 'normal',
  fontFamily: 'default',
  color: 'blue.dark',
  m: 0
};

var H5 = function H5(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h5"
  }, p));
};

H5.defaultProps = {
  lineHeight: 1.5,
  fontSize: 3,
  fontFamily: 'default',
  fontWeight: 'semibold',
  color: 'blue.dark',
  m: 0
};

var H6 = function H6(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "h6"
  }, p));
};

H6.defaultProps = {
  lineHeight: 1.5,
  fontSize: 2,
  fontFamily: 'default',
  fontWeight: 'semibold',
  color: 'blue.mid',
  m: 0
};

Headings.H1 = function (props) {
  return React.createElement(H1, props);
};

Headings.H2 = function (props) {
  return React.createElement(H2, props);
};

Headings.H3 = function (props) {
  return React.createElement(H3, props);
};

Headings.H4 = function (props) {
  return React.createElement(H4, props);
};

Headings.H5 = function (props) {
  return React.createElement(H5, props);
};

Headings.H6 = function (props) {
  return React.createElement(H6, props);
};